import React from 'react'
import { InputText } from '@telavita-core/react-design-kit'
import { MedicalAppointmentFormData } from 'components/MedicalRequestForm/schema'
import { Controller, useFormContext } from 'react-hook-form'

export const ProfessionalDocumentInput = () => {
  const { control, watch } = useFormContext<MedicalAppointmentFormData>()
  const specialtyName = watch('specialty')?.[0]?.type

  return (
    <Controller
      control={control}
      name="professionalDocumentNumber"
      render={({ field, fieldState: { error } }) => (
        <InputText
          {...field}
          onChange={(e) => field.onChange(e.target.value?.replace(/\D/g, ''))}
          handleClearSearchField={() => field.onChange('')}
          floatingLabel={`Número do ${specialtyName}*`}
          hasError={Boolean(error?.message)}
          helperMessage={error?.message}
          helperMessageVariant={error?.message ? 'error' : 'default'}
        />
      )}
    />
  )
}
